<template>
    <div v-if="big" class="flex overflow-hidden">
        <user-avatar v-for="user in users" :key="user.id" :user="user" class="inline-block text-white rounded-full shadow-solid" alt="user-avatar" />
    </div>
    <div v-else class="flex overflow-hidden">
        <div class="flex overflow-hidden">
            <user-avatar v-for="user in users" :key="user.id" :user="user" :small="true" class="inline-block text-white rounded-full shadow-solid" alt="user-avatar" />
        </div>
    </div>
</template>

<script>
import UserAvatar from '@/components/UserAvatar';

export default {
    name: 'user-icon-row',
    components: { UserAvatar },
    props: {
        big: Boolean,
        users: Array,
    },
};
</script>
